import { DocumentoDTO } from "./documentoDTO";
import { DocumentoProtocolloDTO } from "./protocollo/documento-protocolloDTO";
import { DocumentoGescorDTO } from "./gescor/documeto-gescorDTO";
import { ClassificaDTO } from "./classificaDTO";
import { ClassificaGescorDTO } from "./gescor/classifica-gescorDTO";

export class MetadatiProtocolloDTO {
  idBozza: string;

  numeroProtocollo: string;

  dataProtocollo: string;

  tipo: string;

  protocollazioneRiservata: Boolean;

  classifica: ClassificaGescorDTO[];

  riferimentoSegnatura: DocumentoGescorDTO;
}
